import { Menu } from 'antd';
import React from 'react';
import { StoreWrap, config as _c, Block, app } from 'xadmin'

const UserMenuComponent = props => {
  return (
    <>
      <Block name="top.right" >
        {items => {
          return <Menu style={{ maxWidth: 418, minWidth: 240 }} className="top-menu" mode="horizontal">{items}</Menu>
        }}
      </Block>
    </>
  )
}

const paramSchema = () => ({
  type: 'object',
  properties: {}
})

const UserMenu = {
  title: '用户组',
  category: '页面元素',
  icon: '',
  component: UserMenuComponent,
  initLayout: { width: 100, height: 80 },
  paramSchema,
  theme: [
    { selector: '.top-menu', title: '用户组外层样式' },
    { selector: '.top-menu .nav-text', title: '用户组样式' }
  ]
}
export default UserMenu
